import { CommonModule } from "@angular/common";
import { ModuleWithProviders, NgModule } from "@angular/core";
import { MatExpansionModule } from "@angular/material/expansion";
import { CoreModule, UiInteractionService } from "@obg/ngx.core";
import { CoreContentModule } from "@obg/ngx.core.content";
import { GlobalModule } from "@obg/ngx.global";
import { RouterModule } from "@obg/ngx.router";
import { GlobalUiModule } from "@obg/ngx.ui.global";
import { GlobalUiLazyImageModule } from "@obg/ngx.ui.global.lazy-image";

import { BottomDrawerComponent } from "./bottom-drawer/bottom-drawer.component";
import { ContentSectionGroupComponent } from "./content-section-group/content-section-group.component";
import { ContentSectionGroupContainer } from "./content-section-group/content-section-group.container";
import { IconListComponent } from "./icon-list/icon-list.component";
import { ImageContentDirectiveModule } from "./image-content/image-content.module";
import { LanguageSelectorContainer } from "./language-selector/language-selector.container";
import { MenuComponent } from "./menu/menu.component";
import { MenuItemListComponent } from "./menu-item-list/menu-item-list.component";
import { MobileMenuItemListComponent } from "./mobile-menu-item-list/mobile-menu-item-list.component";
import { PageSeoContentContainer } from "./page-seo-content/page-seo-content.container";
import { SeoPropositionMessages } from "./seo-proposition-messages/seo-proposition-messages.component";
import { SeoTagContainer } from "./seo-tag/seo-tag.container";
import { SessionTimerContainer } from "./session-timer/session-timer.container";
import { CORE_UI_INTERACTION_TRACKING_MAP } from "./tracking/tracking.const";
import { UiInteractionDirective } from "./ui-interaction/ui-interaction.directive";

export const CORE_UI_DIRECTIVES: any[] = [
	IconListComponent,
	MenuComponent,
	MenuItemListComponent,
	ContentSectionGroupContainer,
	ContentSectionGroupComponent,
	UiInteractionDirective,
	PageSeoContentContainer,
	SeoPropositionMessages,
	SessionTimerContainer,
	LanguageSelectorContainer,
	SeoTagContainer,
	MobileMenuItemListComponent,
	BottomDrawerComponent,
];

@NgModule({
	imports: [
		CoreModule,
		CommonModule,
		GlobalUiModule,
		GlobalModule,
		RouterModule,
		CoreContentModule,
		GlobalUiLazyImageModule,
		ImageContentDirectiveModule,
		MatExpansionModule,
	],
	exports: [ImageContentDirectiveModule, ...CORE_UI_DIRECTIVES],
	declarations: CORE_UI_DIRECTIVES,
})
export class CoreUiModule {
	constructor(uiInteractionService: UiInteractionService) {
		uiInteractionService.registerTrackingData(CORE_UI_INTERACTION_TRACKING_MAP);
	}

	static forRoot(): ModuleWithProviders<CoreUiModule> {
		return {
			ngModule: CoreUiModule,
		};
	}
}
